import { ChangeEvent, FC, useState } from 'react';
import { Container } from './Support.styles';
import { Button, Message, Section } from '../../../../components';
import { Form, SectionTitle, Separator } from '../../MyAccount.styles';
import { MailOutline } from '@mui/icons-material';
import { useToastStore, useUserStore } from '../../../../stores';
import { postSupport } from '../../../../services';

const Support: FC = () => {
	const { user } = useUserStore();
	const { setToast } = useToastStore();
	const [supportMessage, setSupportMessage] = useState<string>('');

	const handleOnChange = (ev: ChangeEvent<HTMLTextAreaElement>) => {
		const { value } = ev.target;
		setSupportMessage(value);
	};

	const handleSubmitMessage = async () => {
		const body = {
			idUsuario: user!.id.toString(),
			nomeUsuario: user!.nome,
			tipoEmail: 'ContatoApp',
			mensagem: supportMessage,
		};

		try {
			await postSupport(body);
			setSupportMessage('');
			setToast({
				message: 'Mensagem enviada com sucesso!',
				variant: 'success',
			});
		} catch {
			setToast({
				message: 'Erro ao enviar mensagem!',
				variant: 'error',
			});
		}
	};

	return (
		<Container>
			<Section>
				<SectionTitle>Suporte</SectionTitle>
				<Separator />
				<Form>
					<Message
						label='Em que podemos te ajudar?'
						placeholder='Escreva aqui em que podemos te ajudar'
						value={supportMessage}
						onChange={handleOnChange}
					/>
					<Button
						disabled={!supportMessage}
						variant='contained'
						fitContent
						onClick={handleSubmitMessage}
					>
						<MailOutline fontSize='medium' />
						<span>Enviar Mensagem</span>
					</Button>
				</Form>
			</Section>
		</Container>
	);
};

export default Support;
